var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", [
    _c("div", { staticClass: "item-detail__container" }, [
      _c(
        "div",
        { staticClass: "item-detail__info" },
        [
          _c("router-link", { attrs: { tag: "a", to: _vm.link } }, [
            _c("div", { staticClass: "flex flex-wrap items-center" }, [
              _c("div", { staticClass: "item-detail__image" }, [
                _c("img", {
                  staticClass: "profile-image",
                  attrs: { src: _vm.talent.profile_image_url },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "item-detail__details" }, [
                _c("h3", [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.talent.name) +
                      "\n            "
                  ),
                  _vm.talent.profile &&
                  _vm.talent.profile.visibility === "hidden" &&
                  (_vm.$userIsAdmin || _vm.$userIsManager)
                    ? _c("i", {
                        staticClass: "fa fa-eye-slash text-grey",
                        attrs: { "aria-label": "hidden", title: "hidden" },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.talent.profile &&
                  _vm.talent.profile.visibility === "private" &&
                  (_vm.$userIsAdmin || _vm.$userIsManager)
                    ? _c("i", {
                        staticClass: "fa fa-lock text-grey",
                        attrs: { "aria-label": "private", title: "private" },
                      })
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "item-detail__meta" },
                  [
                    !_vm.$vlastMode
                      ? _c("div", [
                          _c("i", { staticClass: "fa fa-fw fa-calendar" }),
                          _vm._v(
                            " Bookings: " +
                              _vm._s(_vm.talent.uncompleted_bookings)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$vlastMode && _vm.talent.talent_bookings_count !== null
                      ? _c("div", [
                          _c("i", { staticClass: "fa fa-fw fa-calendar" }),
                          _vm._v(
                            " Bookings: " +
                              _vm._s(_vm.talent.talent_bookings_count)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.$vlastMode
                      ? _c("div", [
                          _c("i", { staticClass: "fa fa-fw fa-usd" }),
                          _vm._v(
                            " Requests: " +
                              _vm._s(_vm.talent.requests_pending_response)
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.talent.total_time
                      ? _c("div", { attrs: { title: "Total time" } }, [
                          _c("i", { staticClass: "fa fa-clock-o" }),
                          _vm._v(" " + _vm._s(_vm.talent.total_time)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", [
                      _c("i", { staticClass: "fa fa-fw fa-user" }),
                      _vm._v(
                        " Profile: " +
                          _vm._s(_vm.talent.profile_completion_percentage) +
                          "%"
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.$userIsAdmin &&
                    _vm.talent.self_verified &&
                    _vm.$route.params.status === "unverified"
                      ? _c("div", [
                          _c("i", { staticClass: "fa fa-fw fa-check" }),
                          _vm._v(" Self Verified "),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$userIsAdmin && _vm.talent.management
                      ? [
                          _c("div", [
                            _c("i", { staticClass: "fa fa-fw fa-group" }),
                            _vm._v(
                              " " +
                                _vm._s(_vm.talent.management.name) +
                                ", " +
                                _vm._s(_vm.talent.management.company)
                            ),
                          ]),
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$vlastMode && _vm.talent.activation_notified_at
                      ? _c("div", [
                          _c("i", { staticClass: "fa fa-fw fa-clock" }),
                          _vm._v(
                            "Activation Email Sent: " +
                              _vm._s(
                                _vm._f("dateTimezone")(
                                  _vm.talent.activation_notified_at,
                                  _vm.$user.timezone,
                                  _vm.$user.date_format_preference,
                                  true,
                                  true
                                )
                              )
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "item-detail__cta" },
        [
          _vm.canEdit
            ? _c(
                "router-link",
                {
                  staticClass: "btn btn-secondary",
                  attrs: {
                    tag: "a",
                    to: {
                      name: "talent.profile.show",
                      params: { id: _vm.talent.id, status: "event" },
                    },
                  },
                },
                [_vm._v("\n        Edit Profile\n      ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "btn btn-primary",
              attrs: {
                tag: "a",
                to: {
                  name: "talent.profile.view",
                  params: { id: _vm.talent.id, status: "event" },
                },
              },
            },
            [_vm._v("\n        View Profile\n      ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }